/* DEINSPAR – Produktseiten-Rabattbadge. Keine Änderungen an Warenkorb/Preisen. */
(() => {
  'use strict';

  function discountStep(priceCents, compareCents) {
    const price = Number(priceCents);
    const compare = Number(compareCents);
    if (!Number.isFinite(price) || !Number.isFinite(compare) ||
        price < 0 || compare <= 0 || compare <= price) return 0;
    const exactPercent = ((compare - price) / compare) * 100;
    // Kleine Rundungstoleranz nur für Gleitkommaungenauigkeit (z.B. exakt 20%).
    return Math.floor((exactPercent + 1e-9) / 5) * 5;
  }

  function init() {
    document.querySelectorAll('[data-deinspar-product-discount-badge]').forEach(badge => {
      const root = badge.closest('[id^="MainProduct-"]');
      if (!root) return;
      let variants = [];
      try {
        variants = JSON.parse(root.querySelector('[data-deinspar-badge-variants]')?.textContent || '[]');
      } catch (error) {
        console.warn('DEINSPAR: Variantendaten für Rabattbadge ungültig', error);
      }
      const priceById = new Map(variants.map(item => [String(item.id), item]));
      const defaultVariant = variants[0];
      // Der Posterpreis ist unabhängig von den eventuell ausgewählten Set-Rahmen.
      // Das Hauptpreis-Skript schreibt ihn nach jedem Größen-/Rahmenwechsel hierhin.
      let updateTimeout = null;

      function render(price, compare) {
        const percentage = discountStep(price, compare);
        badge.hidden = percentage < 5;
        badge.textContent = percentage >= 5 ? `−${percentage} %` : '';
      }

      function currentVariant() {
        const possibleInputs = root.querySelectorAll('input[name="id"], select[name="id"]');
        for (const input of possibleInputs) {
          const variant = priceById.get(String(input.value));
          if (variant) return variant;
        }
        const urlId = new URLSearchParams(window.location.search).get('variant');
        return priceById.get(String(urlId)) || defaultVariant;
      }

      function posterPricesFromBundle() {
        if (!root.hasAttribute('data-deinspar-poster-price') ||
            !root.hasAttribute('data-deinspar-poster-compare')) return null;
        const price = Number(root.dataset.deinsparPosterPrice);
        const compare = Number(root.dataset.deinsparPosterCompare);
        if (!Number.isFinite(price) || !Number.isFinite(compare)) return null;
        return { price, compare };
      }

      function renderVariant() {
        const poster = posterPricesFromBundle();
        if (poster) {
          render(poster.price, poster.compare);
          return;
        }
        const selected = currentVariant();
        if (selected) render(selected.price, selected.compare_at_price);
      }

      function queueVariantUpdate() {
        // Bei Poster+Rahmen entscheidet das Gesamtpreis-Skript anhand der
        // Poster-Variante; nicht den (falschen) Bundle-Rabatt übernehmen.
        if (posterPricesFromBundle()) return;
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(renderVariant, 0);
        setTimeout(renderVariant, 120);
      }

      root.addEventListener('deinspar:combined-price-updated', event => {
        if (event.target !== root) return;
        const { posterPrice, posterCompareAtPrice } = event.detail || {};
        if (posterPrice !== undefined && posterCompareAtPrice !== undefined) {
          render(posterPrice, posterCompareAtPrice);
        } else {
          renderVariant();
        }
      });
      root.addEventListener('change', queueVariantUpdate);
      root.addEventListener('click', event => {
        if (event.target.closest('[data-custom-size-value], [data-custom-frame-value], .product-form__input, .custom-size-sheet-option, .custom-size-option')) {
          queueVariantUpdate();
        }
      });
      document.addEventListener('variant:change', queueVariantUpdate);

      // Einige Produktvorlagen aktualisieren den Preis nachträglich über Liquid/Ajax.
      // Bei ihnen lesen wir weiterhin die Variante (Cent), nicht formatierten Preistext.
      const priceElement = root.querySelector('.product-detail__price');
      if (priceElement && window.MutationObserver) {
        new MutationObserver(queueVariantUpdate).observe(priceElement, {
          childList: true, subtree: true, characterData: true
        });
      }
      renderVariant();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
